const resolveElements = (elements) => {
	if (typeof elements === "string") {
		elements = document.querySelectorAll(elements)
	} else if (elements instanceof Element) {
		elements = [elements]
	}

	/**
	 * Return an empty array
	 */
	return Array.from(elements || [])
}

export { resolveElements }
